import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/67_card_back_heart_flowers/67_card_back_heart_flowers"
 * Contains 1 texture(s)
 */
export class CardsBacks67CardBackHeartFlowersAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/67_card_back_heart_flowers/67_card_back_heart_flowers';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '67_heart_flowers.png'
    ] as const;
}
